import { escapeHtml } from "@redotech/html/util";

export async function copyToClipboard(text: string) {
  await navigator.clipboard.writeText(text);
}

/**
 * Copy a link to the clipboard as both rich-text (an anchor with `text` as
 * the visible label) and plain-text (the raw URL). Rich-text destinations
 * (Slack, Linear, Notion, Gmail, Docs) paste a clickable label; plain-text
 * destinations get the URL.
 *
 * Falls back to plain-text copy if the browser does not support
 * `navigator.clipboard.write` or the write rejects (e.g. missing permission).
 */
export async function copyLinkToClipboard(text: string, url: string) {
  if (typeof ClipboardItem === "undefined" || !navigator.clipboard.write) {
    await navigator.clipboard.writeText(url);
    return;
  }
  const escaped = escapeHtml(text);
  const escapedUrl = escapeHtml(url);
  const html = `<a href="${escapedUrl}">${escaped}</a>`;
  try {
    await navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([html], { type: "text/html" }),
        "text/plain": new Blob([url], { type: "text/plain" }),
      }),
    ]);
  } catch {
    await navigator.clipboard.writeText(url);
  }
}
